import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {OrderService} from '../../../Services/order.service';
import {IButton} from '../../../../shared/card/card.component';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {Order} from '../../../../back-office/Models/Order';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Helper} from '../../../../helpers/helper.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import * as _ from 'lodash';
import {CollectionService} from '../../../../back-office/Services/collection.service';

@Component({
  selector: 'app-quote-overview',
  templateUrl: './order-overview.component.html',
  styleUrls: ['./order-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class OrderOverviewComponent implements OnInit {
  public grid: Grid;
  public params;
  public orderReference: string;
  public orderId: string;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('expectedDeliveryWeekTemp', {static: true}) expectedDeliveryWeekTemp: ElementRef;
  @ViewChild('cancelModal', {static: false}) cancelModal = null;
  public baseUrl = environment.apiUrl;

  constructor(
    private orderService: OrderService,
    private router: Router,
    private broadcastService: BroadcastService,
    private translator: TranslateService,
    private helper: Helper,
    private auth: AuthenticationService,
    private collectionService: CollectionService) {
  }

  public specialButton: IButton[] = [];
  public specialButtonArray;

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.order.number',
          prop: 'orderNo',
          sortable: true,
          width: 122,
          minWidth: 122,
          maxWidth: 190,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.date',
          prop: 'created',
          sortable: true,
          type: TextColumn.type,
          width: 110,
          minWidth: 110,
          maxWidth: 190,
          translate: true,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.order.reference',
          prop: 'reference',
          sortable: true,
          width: 100,
          minWidth: 100,
          maxWidth: 250,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.by',
          prop: 'author',
          sortable: true,
          width: 80,
          minWidth: 80,
          maxWidth: 250,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row.contact.charAt(0).toUpperCase() + row.contact.slice(1)
        },
        <TextColumn>{
          name: 'doctrine.collection.collections',
          prop: 'orderItemCollections',
          sortable: true,
          type: TextColumn.type,
          width: 85,
          minWidth: 85,
          maxWidth: 250,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.status',
          prop: 'status',
          sortable: true,
          width: 80,
          minWidth: 80,
          maxWidth: 150,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case Order.NEW.key:
                return this.translator.instant('doctrine.order.statuses.new');
              case Order.IN_PROCESS.key:
                return this.translator.instant('doctrine.order.statuses.in_process');
              case Order.DELIVERY.key:
                return this.translator.instant('doctrine.order.statuses.delivery');
              case Order.COMPLETED.key:
                return this.translator.instant('doctrine.order.statuses.completed');
              case Order.ON_HOLD.key:
                return this.translator.instant('doctrine.order.statuses.on_hold');
              case Order.FREE_DELIVERY_AMOUNT_NOT_REACHED.key:
                return this.translator.instant('doctrine.order.statuses.free_delivery_amount_not_reached');
              case Order.CANCELLED.key:
                return this.translator.instant('doctrine.order.statuses.cancelled');
              case Order.CHANGED.key:
                return this.translator.instant('doctrine.order.statuses.changed');
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.order.expected_delivery',
          prop: 'expectedDeliveryWeek',
          sortable: true,
          width: 165,
          minWidth: 165,
          maxWidth: 180,
          type: TextColumn.type,
          translate: true,
          valueTemplate: this.expectedDeliveryWeekTemp
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          width: 300,
          minWidth: 300,
          maxWidth: 300,
          actionItems: [
            <ActionItem>{
              name: 'global.view',
              icon: '',
              status: true,
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('dealer-system/order/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              name: 'global.edit',
              icon: '',
              status: true,
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('dealer-system/order/' + row.id + '/edit'),
              showCallback: (row: Order) => this.isAllowedToEdit(row),
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              name: 'global.cancel',
              icon: '',
              status: true,
              tooltip: 'global.cancel',
              onclick: row => {
                this.orderReference = row.reference;
                this.orderId = row.id;
                this.cancelModal.show();
              },
              showCallback: (row: Order) => {
                const created = moment(row.created).add(Order.DAYS_ALLOWED_FOR_EDITING, 'days');
                const now = moment();
                if ((row.status === Order.NEW.key || row.status === Order.IN_PROCESS.key) && created.isAfter(now)) {
                  return row;
                }
                return;
              },
              btnClass: 'ripple light ms-1'
            },
            // TODO: Uncomment this if you want enable service request feature
            // <ActionItem>{
            //   name: 'global.remarks',
            //   icon: '',
            //   status: true,
            //   tooltip: 'global.remarks',
            //   onclick: row => {
            //     return this.router.navigateByUrl('dealer-system/order/' + row.id + '/service-remark');
            //   },
            //   showCallback: (row: Order) => {
            //     if ([Order.NEW.key, Order.IN_PROCESS.key, Order.DELIVERY.key, Order.ON_HOLD.key].includes(row.status)) {
            //       return row;
            //     }
            //   },
            //   btnClass: 'ripple light ms-1'
            // },
            <ActionItem>{
              name: 'global.services',
              icon: '',
              status: true,
              tooltip: 'global.services',
              onclick: row => this.router.navigateByUrl('dealer-system/order/' + row.id + '/service-request'),
              showCallback: (row: Order) => {
                if (row.status === Order.CANCELLED.key || row.status === Order.CHANGED.key) {
                  return;
                }
                return row;
              },
              // NOTE: uncomment when filter on status is needed
              // disabledCallback: (row:Order) => {
              //   return this.auth.isDealer() && row.status !== Order.COMPLETED.key;
              // },
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              name: 'global.exchange',
              icon: '',
              onclick: row => {
                if(this.auth.isBackOffice()) return this.router.navigateByUrl('/back-office/order/exchange/' + row.id + '/add');
                else return this.router.navigateByUrl('/dealer-system/order/exchange/' + row.id + '/add');
              },
              showCallback: row => !!row,
              disabledCallback: row => !row?.isExchangeable,
              btnClass: 'ripple light ms-1'
            },
          ]
        }

      ],
      service: this.orderService,
      rememberURL: this.router.url,
      method: 'getOrders',
      root: 'order',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          calendarCustomWidth: 39,
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: false,
          hasStatus: true,
          hasNormalSearch: true,
          order: [
            {datepickerOrder: 2, normalSearchOrder: 1, statusOrder: 4}
          ],
          searchArrays: [
            {
              index: 3,
              value: new ServiceSearchItem(this.collectionService, 'getCollections', {sortType: 'ASC', sortBy: 'name'}, (res) => {

                const options = [];
                options.push({value: 'all', label: this.translator.instant('global.all')});
                for (const row of res.data) {
                  options.push({value: row.id, label: row.name});
                }
                return options;
              }),
              name: 'collection_id',
              label: 'doctrine.attributes.collection',
              width: 18,
            },
          ]
        }
      ],
    };

    this.specialButtonArray = [
      {name: this.translator.instant('global.download'), btnIcon: 'feather icon-download', method: 'Download', customClass: 'btn-grey'},
      {name: this.translator.instant('admin.order.new'), btnIcon: 'feather icon-plus', customClass: 'btn-primary', method: 'addOrder'}
    ];
    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });

    });
  }

  calFunction(method: string) {
    this[method]();
  }

  setParams(event) {
    this.params = event;
  }

  Download() {
    this.orderService.downloadOrder(this.params).subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  addOrder() {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(
      () => this.router.navigate(['/dealer-system/order/add'], {replaceUrl: true}));
  }

  cancelOrder() {
    this.orderService.cancelOrder(this.orderId).subscribe((resp) => {
      this.helper.popMessageDialog(
        this.translator.instant('global.success_message.title'),
        this.translator.instant('admin.dealer.order.cancel_alert'),
        'success',
        false
      );
      this.broadcastService.broadcast('refreshGrid', 'getOrders');
      this.cancelModal.hide();
    });
  }

  isAllowedToEdit(row) {
    const created = moment(row.created).add(Order.DAYS_ALLOWED_FOR_EDITING, 'days');
    const now = moment();
    const isOrderNewOrInProcess = (row.status === Order.NEW.key || row.status === Order.IN_PROCESS.key);
    const isNotPastFromAllowedDays = created.isAfter(now);

    if (isOrderNewOrInProcess && isNotPastFromAllowedDays) {
      return row;
    }

    return;
  }

}
